import { render, staticRenderFns } from "./news_form_create.vue?vue&type=template&id=78cc2e1a&"
import script from "./news_form_create.vue?vue&type=script&lang=js&"
export * from "./news_form_create.vue?vue&type=script&lang=js&"
import style0 from "./news_form_create.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports